import { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useJsonLd } from '@/hooks/useJsonLd';

const FAQItem = ({ q, a, index }) => {
  const [open, setOpen] = useState(false);

  return (
    <button
      onClick={() => setOpen(!open)}
      className={`w-full text-left p-5 rounded-xl border transition-all duration-200 ${
        open ? 'bg-white border-[#D4AF37]/30 shadow-sm' : 'bg-white/50 border-[#E1DFD7] hover:border-[#D4AF37]/20'
      }`}
      data-testid={`faq-item-${index}`}
      aria-expanded={open}
    >
      <div className="flex items-start justify-between gap-3">
        <h3 className="font-semibold text-[#0B2240] text-sm sm:text-base">{q}</h3>
        {open ? <ChevronUp className="h-5 w-5 text-[#D4AF37] flex-shrink-0" /> : <ChevronDown className="h-5 w-5 text-[#4C5A70] flex-shrink-0" />}
      </div>
      {open && <p className="mt-3 text-sm text-[#4C5A70] leading-relaxed">{a}</p>}
    </button>
  );
};

export const ServiceFAQ = ({ faqs, title = "Frequently Asked Questions" }) => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": (faqs || []).map(faq => ({
      "@type": "Question",
      "name": faq.q,
      "acceptedAnswer": { "@type": "Answer", "text": faq.a }
    }))
  };
  useJsonLd(`service-faq-${title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`, faqSchema);

  return (
    <>
      <section className="py-20 bg-[#F7F6F2]" data-testid="service-faq-section">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl font-semibold text-[#0B2240]">
              {title}
            </h2>
          </motion.div>
          <div className="space-y-3">
            {(faqs || []).map((faq, i) => (
              <FAQItem key={i} q={faq.q} a={faq.a} index={i} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};
